import { combineReducers } from "redux"
import { CLEAR_PRODUCT_DATA, LOAD_FOR_PRODUCT_START } from "./productData"

const CHANGE_SHARE_MODE = "jass/statistics/ui/CHANGE_SHARE_MODE"

const selectedProduct = (state = null, action) => {
  switch (action.type) {
    case CLEAR_PRODUCT_DATA:
      return null
    case LOAD_FOR_PRODUCT_START:
      return action.position
    default:
      return state
  }
}

const sharesMode = (state = "views", action) => {
  switch (action.type) {
    case CHANGE_SHARE_MODE:
      return action.mode
    default:
      return state
  }
}

export const changeShareMode = (mode) => {
  return {
    type: CHANGE_SHARE_MODE,
    mode
  }
}

export default combineReducers({
  selectedProduct,
  sharesMode
})
